export default "__VITE_ASSET__nSNXnSB9__"